import { isContainerBlock, type TBlock, type TCssStyle, type TTemplate } from '@wp-block-builder/package';

type TCallback = (b: TBlock) => void;

function eachBlock(blocks: (TBlock | null)[], callback: TCallback) {
  for (const b of blocks) {
    if (!b) {
      continue;
    }
    callback(b);
    if (isContainerBlock(b)) {
      eachBlock(b.props?.blocks || [], callback);
    }
  }
}

function collectColors(obj: undefined | null | Record<string, unknown>, names: string[]): string[] {
  if (obj === undefined || obj === null) {
    return [];
  }
  return names
    .map((n) => obj[n])
    .filter((v) => typeof v === 'string')
    .map((v) => (v as string).toUpperCase())
    .filter((v) => v.match(/^#[0-9a-fA-F]{6}$/));
}

const CSS_COLOR_NAMES: (keyof TCssStyle)[] = ['backgroundColor', 'color'];
const getStyleColors = (style: TCssStyle) => collectColors(style, CSS_COLOR_NAMES);

export default function getCustomColors(template: TTemplate) {
  const colors: string[] = [];
  colors.push(...getStyleColors(template.backdropStyle));
  colors.push(...getStyleColors(template.canvasStyle));
  colors.push(...getStyleColors(template.linkStyle));
  eachBlock(template.blocks, (b) => {
    colors.push(...getStyleColors(b.style || {}));
    colors.push(...getBlockPropsColors(b));
  });
  return colors;
}

function getBlockPropsColors(block: TBlock): string[] {
  switch (block.type) {
    case 'Avatar':
      return collectColors(block.props, ['fallbackColor']);
    case 'Button':
      return collectColors(block.props, ['buttonBackgroundColor', 'buttonTextColor']);
    case 'Divider':
      return collectColors(block.props, ['lineColor']);
    case 'ColumnsSection':
    case 'Container':
    case 'ContainerYield':
    default:
      return [];
  }
}
